import {ID, Model, ResponseSerialize} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'

export default class CargaRequest extends Model {
  id: ID | null = null

  @ResponseSerialize(Carga)
  item: Carga | null = null

  ids: ID[] | null = null

  @ResponseSerialize(Carga)
  items: Carga[] = []

  viaPainel: boolean | null = null

  removeAssociation: boolean | null = null

  senhaExcluirNotas: string | null = null
  justificativaExcluirNotas: string | null = null
  validarExcluirNota: boolean | null = null
}
